// @flow
import { getBaseUrl, getClassicBaseUrl } from '../../../redux/modules/config';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LACrown from './LACrown';

const mapStateToProps = state => {
    return {
        baseUrl: getBaseUrl(state),
        classicBaseUrl: getClassicBaseUrl(state),
    };
};

type Props = {
    baseUrl: string,
    classicBaseUrl: string,
    pathname: string,
};

class LACrownContainer extends Component<Props> {
    render() {
        const { baseUrl, classicBaseUrl, pathname } = this.props;

        return <LACrown baseUrl={baseUrl} classicBaseUrl={classicBaseUrl} pathname={pathname} />;
    }
}

export default connect(mapStateToProps)(LACrownContainer);
